import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.983 0L6 3.983 2.017 0 0 2.017 3.982 6 0 9.982 2.017 12l3.982-3.985L9.983 12 12 9.982 8.017 6 12 2.017 9.983 0z" fill="#888" /></svg>;